import axios from "axios";

const prescriptionInstance = axios.create({
  baseURL: `http://3.113.123.43:5000`,
});
//add1
export const addPrescriptionEffect = (formData, token) => {
  console.log("formData-111formData", formData);
  return prescriptionInstance.request({
    url: "/prescription/add",
    method: "POST",
    data: formData,
    headers: {
      organization_id: localStorage.getItem("org_id"),
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
//list
export const prescriptionListEffect = (formData, token) => {
  return prescriptionInstance.request({
    url: `/prescription/organization?pageNo=${formData}&pagesize=10&pagination_required=false`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
//no need
export const prescriptionDataEffect = (formData, token) => {
  return prescriptionInstance.request({
    url: "prescription/list",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/x-www-form-urlencoded",
    },
  });
};
//noneed
export const prescriptionByPatientEffect = (formData, token) => {
  console.log("formData", formData);
  return prescriptionInstance.request({
    url: `/prescription/appointment/${formData}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/x-www-form-urlencoded",
    },
  });
};
//add rowww
export const SavePrescriptionEffect = ({
  prescriptionId,
  prescription_details,
  special_instructions,
}) => {
  console.log("formData", prescription_details);
  console.log("prescriptionId", prescriptionId);
  const token = localStorage.getItem("user_id");
  return prescriptionInstance.request({
    url: `/prescription/savePrescription/${prescriptionId}`,
    method: "PUT",
    data: {
      prescription_details: prescription_details,
      special_instructions: special_instructions,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
//delete
export const CancelPrescriptionEffect = (formData, token) => {
  console.log("formData", formData);
  const id = formData;
  console.log("id", id);
  return prescriptionInstance.request({
    url: `/prescription/cancelPrescription/${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
//finsl submits
export const SubmitPrescriptionEffect = ({
  prescriptionId,
  prescription_details,
}) => {
  const token = localStorage.getItem("user_id");
  return prescriptionInstance.request({
    url: `/prescription/submitPrescription/${prescriptionId}`,
    method: "PUT",
    data: { prescription_details: prescription_details },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const seenPrescriptionEffect = ({ prescriptionId }) => {
  console.log(prescriptionId);
  const token = localStorage.getItem("user_id");
  return prescriptionInstance.request({
    url: `prescription/pharmacies/${prescriptionId}`,
    method: "GET",

    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
